/*
         * @ngdoc function
         * @name ePay.Model:Session_PreQuestionareModel
         * @description
         * Model
         */
import { Session_PreQuestionNumberModel } from './Session_PreQuestionNumberModel';

export class Session_PreQuestionareModel {
	preQuestionNumber: Session_PreQuestionNumberModel[];

	constructor(
		preQuestionNumber?: Session_PreQuestionNumberModel[]
	) {
		this.preQuestionNumber = preQuestionNumber || [];
	}
}
